import React from 'react';

const IconHex = () => (
  <svg id="circle" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Circle</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <circle
          cx="39"
          cy="45"
          r="39"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconHex;
